// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S0ZNP{overflow:auto}.io68h{max-width:700px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `S0ZNP`,
	"inner": `io68h`
};
export default ___CSS_LOADER_EXPORT___;
